import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatFeeEmployeejobModel } from 'src/app/model/cat-fee-employee-job-model';

@Injectable({
  providedIn: 'root'
})
export class CatFeeEmployeeJobService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  catalog=()=> {
    return this.http.get(`${this.url}/CatFeeEmployeeJob/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAll=()=> {
    return this.http.get(`${this.url}/CatFeeEmployeeJob/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllActive=()=> {
    return this.http.get(`${this.url}/CatFeeEmployeeJob/List`)
      .pipe(
        map((resp:any)=> resp.filter(fee=> fee.activeId))
      );
  }
  save=(fee:CatFeeEmployeejobModel)=> {
    return this.http.post(`${this.url}/CatFeeEmployeeJob/SaveUpdate`, fee)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(fee:CatFeeEmployeejobModel)=> {
    return this.http.post(`${this.url}/CatFeeEmployeeJob/SaveUpdate/${fee.feeEmployeeJobId}`, fee)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
